window.detailFormatter = function(value, row) {
    let html = '';
    if (!row.detail) {
        return html;
    }
    html += '<table class="table table-bordered">';
    html += '<thead>';
    html += '<tr>';
    html += '<th scope="col" class="p-3">'+row.detail.header+'</th>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<td class="p-3" style="white-space:nowrap">';
    html += '<div style="white-space: normal !important">';
    html += row.detail.html;
    html += '</div>';
    html += '</th>';
    html += '</tbody>';
    html += '</table>';
    return html;
};
